import {
  AppBar,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogContentText,
  Grid,
  List,
  ThemeProvider,
  Toolbar,
  createTheme,
  styled,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import AuthContext from "../../auth/context";
import api from "../../services/api";
import AppContext from "../../pages/app/context";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

let ciclosProfissional = [];

export default function SelecaoCiclo(props) {
  const usuario = useContext(AuthContext);
  const dadosProps = props.location.state;
  const [checkCiclos, setCheckCiclos] = useState([]);
  const [open, setOpen] = useState(false);
  const history = useHistory();
  const { notification } = useContext(AppContext);

  useEffect(() => {
    if (dadosProps.viaPerfil) {
      obterCiclosProfissional();
    }
  }, []);

  const obterCiclosProfissional = () => {
    api
      .get("profissionais/listarCiclos", {
        profissionalId: usuario.usuario.profissionalId,
        todos: true,
      })
      .then((res) => {
        res.forEach((c) => (c.marcado = c.cicloProfissionalId ? true : false));

        setCheckCiclos(res);
      })
      .catch((err) =>
        alert("Erro ao listar os ciclos do profissional: " + err)
      );
  };

  const selecionarCiclo = (id) => {
    const checkAtualizar = [...checkCiclos];

    checkAtualizar.forEach((cc) => {
      if (cc.id === id) cc.marcado = !cc.marcado;
    });

    setCheckCiclos(checkAtualizar);
  };

  const cadastrar = () => {
    if (checkCiclos.filter((cc) => cc.marcado).length === 0) {
      //Caso nenhum ciclo seja informado, confirmar
      setOpen(true);
    } else {
      salvar();
    }
  };

  const salvar = () => {
    checkCiclos.forEach((ciclo) => {
      const vinculo = {
        profissionalId: usuario.usuario.profissionalId,
        cicloId: ciclo.id,
      };

      if (ciclo.marcado) {
        api
          .post("/profissionais/vincularCiclo", vinculo)
          .then(() => {
            // setCiclos(ciclosAtualizar);
            notification("success", "Alteração salva: Ciclo incluído.");
          })
          .catch(() => {
            notification(
              "error",
              "Não foi possível salvar a alteração. Verifique sua conexão e tente novamente."
            );
          });
      } else if (dadosProps.viaPerfil) {
        api
          .post("/profissionais/desvincularCiclo", vinculo)
          .then(() => {
            // setCiclos(ciclosAtualizar);
            notification("success", "Alteração salva: Ciclo removido.");
          })
          .catch(() => {
            notification(
              "error",
              "Não foi possível salvar a alteração. Verifique sua conexão e tente novamente."
            );
          });
      }
    });

    if (dadosProps.viaPerfil) {
      notification("success", "Ciclos salvos!");
      history.push("perfil");
    } else {
      console.log("Cadastro finalizado com sucesso!");
      // this.props.navigation.navigate('Login');
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <AppBar position="fixed">
        <Toolbar style={{ background: "#3d79bd" }}>
          <ArrowBackIcon
            onClick={() => history.push("perfil")}
            style={{
              color: "white",
              marginRight: 20,
              cursor: "pointer",
            }}
          />

          <h2
            style={{
              fontWeight: "bolder",
              color: "white",
              fontFamily: "Gilroy-ExtraBold",
            }}
          >
            Gerenciar ciclos
          </h2>
        </Toolbar>
      </AppBar>
      <Toolbar />

      <Box
        sx={{
          // margin: 2,
          // marginTop: 10,
          width: "100%",
          // bgcolor: "background.paper",
        }}
      >
        <br />
        <Main
          style={{
            background: "white",
            fontFamily: "Gilroy-ExtraBold",
          }}
        >
          <Grid container>
            <Grid
              item
              xs={12}
              style={{ textAlign: "center", color: "#A3A3A3" }}
            >
              <h3>Selecione os ciclos com os quais trabalha</h3>
            </Grid>

            <Grid item xs={12}>
              <List
                sx={{
                  // margin: 2,
                  bgcolor: "background.paper",
                }}
              >
                {checkCiclos.map((item, index) => (
                  <>
                    <li
                      style={{
                        cursor: "pointer",
                        background: "#A3A3A3",
                        color: "white",
                      }}
                      disablePadding
                    >
                      <Grid container style={{ paddingLeft: 15 }}>
                        <Grid item xs={2}>
                          <Checkbox
                            onChange={() => selecionarCiclo(item.id)}
                            checked={item.marcado}
                          />
                        </Grid>
                        <Grid
                          style={{ display: "flex" }}
                          alignItems="center"
                          item
                          xs={10}
                        >
                          <h4>{item.nome}</h4>
                        </Grid>
                      </Grid>
                    </li>
                    <br />
                  </>
                ))}
              </List>
            </Grid>

            <Grid item xs={12} style={{ textAlign: "center" }}>
              <ThemeProvider theme={theme}>
                <Button
                  fullWidth
                  style={{
                    color: "white",
                    marginTop: "10px",
                    marginBottom: "10px",
                    fontWeight: "bold",
                    width: "50%",
                    fontFamily: "Gilroy-ExtraBold",
                  }}
                  onClick={() => cadastrar()}
                  variant="contained"
                >
                  Salvar
                </Button>
              </ThemeProvider>
            </Grid>
          </Grid>
          <br />
          <Toolbar />
        </Main>
      </Box>

      <Dialog
        onClose={handleClose}
        fullWidth={true}
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <h3>Ciclo não informado</h3>
            <br />
            <h4>Nenhum ciclo foi selecionado. Deseja continuar?</h4>
          </DialogContentText>
          <br />

          <Button
            variant="contained"
            onClick={() => {
              salvar();
              setOpen(false);
            }}
          >
            confirmar
          </Button>
          <Button
            style={{ margin: "0px 0px 0px 10px" }}
            variant="contained"
            onClick={() => {
              setOpen(false);
            }}
          >
            Fechar
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
}

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    // padding: theme.spacing(1),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 250,
    }),
  })
);

const theme = createTheme({
  palette: {
    primary: {
      main: "#F5B01B",
    },
  },
});
